/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */


import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import * as models from '../model/models';
import { Requester } from '../requester';
import { PagedArray } from '../paged-array';

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class ReportCenterApi {
    constructor(
        protected requester: Requester
    ) {
    }

    /**
     * Get report center pages
     */
    public getReportCenterPages(__unused?: any): Observable<PagedArray<models.ApiReportCenterPage>> {
        const path = '/report-center/pages';

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<PagedArray<models.ApiReportCenterPage>>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

}
